import { VStack } from "@gluestack-ui/themed";
import { Text } from "@repo/core/components/core/Text";
import { GeneralInfoProps } from "./types";

export const GeneralInfo = ({ name, value }: GeneralInfoProps) => {
  return (
    <VStack gap={4}>
      <Text fontSize="$xs" fontWeight={500}>
        {name}
      </Text>
      <Text>{value}</Text>
    </VStack>
  );
};
